import React, {useCallback, useEffect, useRef, useState} from 'react';
import post from '../utils/post.js';

const SUMMARY_FILTERS = {
	NUKI: 'nuki',
	OTHERS: 'others',
};

const SUMMARY_CARDS = [
	{id: SUMMARY_FILTERS.NUKI, label: 'NUKI', key: 'nuki', toneClassName: 'userlog-list__summary-card--success'},
	{id: SUMMARY_FILTERS.OTHERS, label: 'OTHERS', key: 'others', toneClassName: 'userlog-list__summary-card--warning'},
];

// Sdílený výpis user logů – používá ho stránka /userlog i popup s logy uživatele
// v monitoringu. Hledaný výraz je řízený zvenku (stránka ho drží v horní liště,
// popup ho předvyplňuje e-mailem uživatele), zbytek stavu (data, filtr, offset)
// si komponenta drží sama.
export default function UserLogList({searchValue = '', listRows, variant = '', onLoadingChange}) {
	const [data, setData] = useState([]);
	const [summary, setSummary] = useState({nuki: 0, others: 0});
	const [activeSummaryFilter, setActiveSummaryFilter] = useState(null);
	const [loadedCnt, setLoadedCnt] = useState(0);
	const [loading, setLoading] = useState(false);

	const offsetRef = useRef(0);
	const rowsPerPage = parseInt(listRows, 10) || 25;

	useEffect(() => {
		if (onLoadingChange) {
			onLoadingChange(loading);
		}
	}, [loading, onLoadingChange]);

	const getData = useCallback(
		(search, offset, summaryFilter) => {
			setLoading(true);
			offsetRef.current = offset;

			post('getListUserLog', {search: search, offset: offset, summaryFilter: summaryFilter})
				.then((res) => {
					const rows = res.data || [];

					if (offset === 0) {
						setData(rows);
					} else {
						setData((prevRows) => [...prevRows, ...rows]);
					}

					setLoadedCnt(rows.length);
					setSummary(res.summary || {nuki: 0, others: 0});
					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		},
		[],
	);

	// Změna hledání nebo filtru → načteme vždy od začátku.
	useEffect(() => {
		getData(searchValue, 0, activeSummaryFilter);
	}, [getData, searchValue, activeSummaryFilter]);

	const loadNext = () => {
		getData(searchValue, offsetRef.current + rowsPerPage, activeSummaryFilter);
	};

	const toggleSummaryFilter = (summaryFilter) => {
		setActiveSummaryFilter((prevFilter) => (prevFilter === summaryFilter ? null : summaryFilter));
	};

	// Stejná struktura řádku jako „Poslední logy" v monitoringu: vlevo datum
	// a pod ním akce, vpravo e-mail a pod ním jméno uživatele.
	const list = data.map((line, index) => (
		<article className={`userlog-list__row${parseInt(line.IS_TODAY, 10) === 1 ? ' userlog-list__row--today' : ''}`} key={index}>
			<div className="userlog-list__row-left">
				<span className="userlog-list__row-date">{line.CRDTS}</span>
				<div className={`userlog-list__row-action${parseInt(line.SMARTLOCK, 10) === 1 ? ' userlog-list__row-action--smartlock' : ''}`}>{line.ACTION}</div>
			</div>
			<div className="userlog-list__row-user-wrap">
				<span className="userlog-list__row-user">{line.USR}</span>
				{line.USRNAME ? <span className="userlog-list__row-name">{line.USRNAME}</span> : null}
			</div>
		</article>
	));

	return (
		<div className={`userlog-list${variant !== '' ? ` userlog-list--${variant}` : ''}`}>
			<div className="userlog-list__summary-panel">
				<div className="userlog-list__summary-grid">
					{SUMMARY_CARDS.map((card) => {
						const isActive = activeSummaryFilter === card.id;

						return (
							<button className={`home-summary-card userlog-list__summary-card ${card.toneClassName}${isActive ? ' is-active' : ''}`} key={card.id} type="button" aria-pressed={isActive} onClick={() => toggleSummaryFilter(card.id)}>
								<div className="home-summary-card__content">
									<span className="home-summary-card__eyebrow">{card.label}</span>
									<span className="home-summary-card__value">{summary[card.key]}</span>
								</div>
							</button>
						);
					})}
				</div>
			</div>

			<div className="userlog-list__content">
				<div className="userlog-list__list">{list.length > 0 ? list : <div className="userlog-list__empty">{loading ? 'Načítám logy...' : 'Zatím nejsou k dispozici žádné logy.'}</div>}</div>

				<div className="userlog-list__load-more">
					{parseInt(loadedCnt, 10) === rowsPerPage ? (
						<button type="button" className="button small loadNext userlog-list__button" onClick={() => loadNext()} disabled={loading}>
							Načíst další
						</button>
					) : (
						<span className="fnt_12 loadNext userlog-list__load-all">Byly načteny všechny záznamy</span>
					)}
				</div>
			</div>
		</div>
	);
}
